import { SDLCMetadataTypeGuards } from "@sscs/types";
import { compareValues, isRegexMatch } from "@sscs/utils";
import { UNDECLARED_LICENSE } from "../../../constants";
import { publisherMatchesFilter } from "../../../utils";
export const initFilter = {
    dependencyId: null,
    dependencyName: "",
    linking: "ALL",
    license: null,
    publisher: null,
    matches: [],
    maliciousOnly: false,
};
export const initSort = {
    property: "cve",
    reverse: true,
};
export const specialCasesForSorting = {
    license: (first, second, reverse) => compareValues(first.identity.license, second.identity.license, reverse),
    dependency_name: (first, second, reverse) => compareValues(first.identity.product, second.identity.product, reverse),
    publisher: (first, second, reverse) => compareValues(first.identity.publisher, second.identity.publisher, reverse),
    cve: (first, second, reverse) => compareValues(first.identity.vulnerabilities.total_count, second.identity.vulnerabilities.total_count, reverse),
    threat_name: (first, second, reverse) => compareValues(first.classification.result, second.classification.result, reverse),
};
export const filterDependencies = (dependencies, filter) => {
    const hasIdFilter = filter.dependencyId !== null;
    const hasNameFilter = filter.dependencyName !== initFilter.dependencyName;
    const hasLicenseFilter = filter.license !== initFilter.license;
    const hasPublisherFilter = filter.publisher !== initFilter.publisher;
    const hasLinkingFilter = filter.linking !== initFilter.linking;
    const hasVerifiedFilter = filter.matches.length > 0;
    const hasMaliciousOnlyFilter = filter.maliciousOnly;
    if (!hasIdFilter &&
        !hasNameFilter &&
        !hasLicenseFilter &&
        !hasPublisherFilter &&
        !hasLinkingFilter &&
        !hasVerifiedFilter &&
        !hasMaliciousOnlyFilter) {
        return dependencies;
    }
    return dependencies.filter((dependency) => {
        var _a;
        var _b, _c;
        if (hasIdFilter && dependency.identity.uuid !== filter.dependencyId)
            return false;
        if (hasMaliciousOnlyFilter &&
            dependency.classification.classification !== "Malicious")
            return false;
        if (hasNameFilter &&
            !isRegexMatch(dependency.identity.product, filter.dependencyName))
            return false;
        if (hasLicenseFilter) {
            if (filter.license === UNDECLARED_LICENSE) {
                if (dependency.identity.license !== "")
                    return false;
            }
            else {
                if (!dependency.identity.license
                    .toLowerCase()
                    .startsWith((_b = (_a = filter.license) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : ""))
                    return false;
            }
        }
        if (hasPublisherFilter &&
            !publisherMatchesFilter(dependency.identity.publisher, (_c = filter.publisher) !== null && _c !== void 0 ? _c : "")) {
            return false;
        }
        if (hasLinkingFilter) {
            if (SDLCMetadataTypeGuards.stringIsDependencyLinking(filter.linking) &&
                dependency.linking !== filter.linking) {
                return false;
            }
            if (SDLCMetadataTypeGuards.stringIsSoftwareScenario(filter.linking) &&
                (dependency.identity.scenario !== filter.linking ||
                    dependency.linking !== "package")) {
                return false;
            }
        }
        if (hasVerifiedFilter &&
            !filter.matches.includes(dependency.identity.verified)) {
            return false;
        }
        return true;
    });
};
//# sourceMappingURL=utils.js.map